import { CommonEnums } from 'src/app/shared/common.enums';

export class MJnr_Inst {
    mJnr_Inst_Id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    jnrFltrCnd: string;
    jnrFltrCndValid_Cd: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    primObjId: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    prop_Tab_Valid_Cd: string;
    attr_Tab_Valid_Cd: string;
    lattr_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.mJnr_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.jnrFltrCnd = CommonEnums.defaults.STRING_EMPTY;
        this.jnrFltrCndValid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.primObjId = CommonEnums.defaults.LONG_VAL;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.lattr_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
    }

    getPrimaryKey(): string {
        return this.dxMp_Id + '.' + this.mJnr_Inst_Id;
    }

    static parse(mJnr_InstTmp: MJnr_Inst): MJnr_Inst {
        let mJnr_Inst: MJnr_Inst = new MJnr_Inst();
        mJnr_Inst.copyFrom(mJnr_InstTmp);
        return mJnr_Inst;
    }

    copy(): MJnr_Inst {
        let mJnr_InstTmp: MJnr_Inst = new MJnr_Inst();

        mJnr_InstTmp.mJnr_Inst_Id = this.mJnr_Inst_Id;
        mJnr_InstTmp.dxMp_Id = this.dxMp_Id;
        mJnr_InstTmp.nm = this.nm;
        mJnr_InstTmp.description = this.description;
        mJnr_InstTmp.jnrFltrCnd = this.jnrFltrCnd;
        mJnr_InstTmp.jnrFltrCndValid_Cd = this.jnrFltrCndValid_Cd;
        mJnr_InstTmp.ver = this.ver;
        mJnr_InstTmp.valid_Cd = this.valid_Cd;
        mJnr_InstTmp.primObjId = this.primObjId;
        mJnr_InstTmp.updateDt = this.updateDt;
        mJnr_InstTmp.updateBy = this.updateBy;
        mJnr_InstTmp.lastUpdateBy = this.lastUpdateBy;
        mJnr_InstTmp.persistFlg = this.persistFlg;

        mJnr_InstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;
        mJnr_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;
        mJnr_InstTmp.lattr_Tab_Valid_Cd = this.lattr_Tab_Valid_Cd;

        return mJnr_InstTmp;
    }

    copyFrom(mJnr_InstTmp: MJnr_Inst): void {
        this.mJnr_Inst_Id = mJnr_InstTmp.mJnr_Inst_Id;
        this.dxMp_Id = mJnr_InstTmp.dxMp_Id;
        this.nm = mJnr_InstTmp.nm;
        this.description = mJnr_InstTmp.description;
        this.jnrFltrCnd = mJnr_InstTmp.jnrFltrCnd;
        this.jnrFltrCndValid_Cd = mJnr_InstTmp.jnrFltrCndValid_Cd;
        this.ver = mJnr_InstTmp.ver;
        this.valid_Cd = mJnr_InstTmp.valid_Cd;
        this.primObjId = mJnr_InstTmp.primObjId;
        this.updateDt = mJnr_InstTmp.updateDt;
        this.updateBy = mJnr_InstTmp.updateBy;
        this.lastUpdateBy = mJnr_InstTmp.lastUpdateBy;
        this.persistFlg = mJnr_InstTmp.persistFlg;

        this.prop_Tab_Valid_Cd = mJnr_InstTmp.prop_Tab_Valid_Cd;
        this.attr_Tab_Valid_Cd = mJnr_InstTmp.attr_Tab_Valid_Cd;
        this.lattr_Tab_Valid_Cd = mJnr_InstTmp.lattr_Tab_Valid_Cd;
    }

    compare(mJnr_InstTmp: MJnr_Inst): string {
        let mJnr_InstString: string = this.toString(false);
        let mJnr_InstTmpString: string = mJnr_InstTmp.toString(false);

        if (mJnr_InstString != mJnr_InstTmpString) {
            return mJnr_InstString + ', ' + mJnr_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "MJnr_Inst [mJnr_Inst_Id=" + this.mJnr_Inst_Id + ", dxMp_Id=" + this.dxMp_Id + ", nm=" + this.nm +
            ", description=" + this.description + ", jnrFltrCnd=" + this.jnrFltrCnd + ", jnrFltrCndValid_Cde=" + this.jnrFltrCndValid_Cd +
            ", valid_Cd=" + this.valid_Cd + ", persistFlg=" + this.persistFlg + ", primObjId=" + this.primObjId +
            ", prop_Tab_Valid_Cdg=" + this.prop_Tab_Valid_Cd + ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd  + ", lattr_Tab_Valid_Cd=" + this.lattr_Tab_Valid_Cd;

        if (isNotCompare) {
            str += ", ver=" + this.ver + ", updateBy=" + this.updateBy + ", lastUpdateBy=" + this.lastUpdateBy +
                ", updateDt=" + this.updateDt;
        }

        str += ']';
        return str;
    }
}